import { isMobile } from "react-device-detect";

export const isUniversalLink = () => {
  return /(challenges|upgrade-to-enhanced-gps)/.test(window.location.pathname);
};

export const isUnivarsal = (link) => {
  return window.location.pathname.includes(link);
};

export const mobileStoreRedirect = () => {
  const navigationType =
    window.performance.getEntriesByType("navigation")[0].type;
  if (navigationType !== "navigate") return;

  let link = "";
  if (!isMobile) {
    // upgrade to upgrade-to-enhanced-gps fallback
    if (isUnivarsal("upgrade-to-enhanced-gps"))
      link =
        "https://www.usga.org/content/usga/home-page/Handicap-ghin/GHIN-Sentry.html";
  } else {
    // Detect whether the user is on iOS or Android
    var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    var isAndroid = /Android/i.test(navigator.userAgent);

    // Set the correct store link
    if (isIOS) {
      link = "https://itunes.apple.com/us/app/ghin-mobile/id491796218?mt=8";
    } else if (isAndroid) {
      link =
        "https://play.google.com/store/apps/details?id=com.advancedmobile.android.ghin&amp;hl=en_US";
    } else {
      return;
    }
  }

  // If mobile -> Redirect to App Store or Google Play
  // If web -> redirect to a specific page
  if (link === "") return;

  window.location = link;
};
